export const getThemeColor = (selectedTheme, themeColors) => {
    return themeColors[selectedTheme ?? 'light'];
};
